// BEGIN sps2plusCompleteGallery20260716
;(function sps2plusCompleteGallery20260716() {
  var config = {
  "handle": "premium-seibertron-sps2-plus-summer-motorcycle-gloves-abrasion-resistant-carbon-fiber-knuckles-ventilated-comfort",
  "entries": [
    {
      "id": "33403640348862",
      "color": "Gray",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/2_c70b6825-9e2e-4945-889d-4b8b7576e7f3.jpg?v=1783672404",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves gray white background main"
    },
    {
      "id": "33375892537534",
      "color": "Gray",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-19.jpg?v=1783410528",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves gray feature 1"
    },
    {
      "id": "33375892570302",
      "color": "Gray",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-20.jpg?v=1783410528",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves gray feature 2"
    },
    {
      "id": "33375892603070",
      "color": "Gray",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-21.jpg?v=1783410528",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves gray feature 3"
    },
    {
      "id": "33375892635838",
      "color": "Gray",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-22.jpg?v=1783410528",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves gray feature 4"
    },
    {
      "id": "33375892668606",
      "color": "Gray",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-23.jpg?v=1783410527",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves gray scene 1"
    },
    {
      "id": "33375892701374",
      "color": "Gray",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-24.jpg?v=1783410528",
      "alt": "color:Gray | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves gray scene 2"
    },
    {
      "id": "33455530639550",
      "color": "Black",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-black-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves black white background main"
    },
    {
      "id": "33375891947710",
      "color": "Black",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-01.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves black feature 1"
    },
    {
      "id": "33375891980478",
      "color": "Black",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-02.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves black feature 2"
    },
    {
      "id": "33375892013246",
      "color": "Black",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-03.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves black feature 3"
    },
    {
      "id": "33375892046014",
      "color": "Black",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-04.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves black feature 4"
    },
    {
      "id": "33375892078782",
      "color": "Black",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-05.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves black scene 1"
    },
    {
      "id": "33375892111550",
      "color": "Black",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-06.jpg?v=1783410528",
      "alt": "color:Black | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves black scene 2"
    },
    {
      "id": "33455530672318",
      "color": "Orange",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-orange-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves orange white background main"
    },
    {
      "id": "33375892340926",
      "color": "Orange",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-13.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves orange feature 1"
    },
    {
      "id": "33375892373694",
      "color": "Orange",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-14.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves orange feature 2"
    },
    {
      "id": "33375892406462",
      "color": "Orange",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-15.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves orange feature 3"
    },
    {
      "id": "33375892439230",
      "color": "Orange",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-16.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves orange feature 4"
    },
    {
      "id": "33375892471998",
      "color": "Orange",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-17.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves orange scene 1"
    },
    {
      "id": "33375892504766",
      "color": "Orange",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-18.jpg?v=1783410528",
      "alt": "color:Orange | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves orange scene 2"
    },
    {
      "id": "33455530705086",
      "color": "Red",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-red-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves red white background main"
    },
    {
      "id": "33375892734142",
      "color": "Red",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-25.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves red feature 1"
    },
    {
      "id": "33375892766910",
      "color": "Red",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-26.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves red feature 2"
    },
    {
      "id": "33375892799678",
      "color": "Red",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-27.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves red feature 3"
    },
    {
      "id": "33375892832446",
      "color": "Red",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-28.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves red feature 4"
    },
    {
      "id": "33375892865214",
      "color": "Red",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-29.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves red scene 1"
    },
    {
      "id": "33375892897982",
      "color": "Red",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-30.jpg?v=1783410528",
      "alt": "color:Red | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves red scene 2"
    },
    {
      "id": "33455530737854",
      "color": "White",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-white-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves white white background main"
    },
    {
      "id": "33375892144318",
      "color": "White",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-07.jpg?v=1783410527",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves white feature 1"
    },
    {
      "id": "33375892177086",
      "color": "White",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-08.jpg?v=1783410528",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves white feature 2"
    },
    {
      "id": "33375892209854",
      "color": "White",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-09.jpg?v=1783410528",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves white feature 3"
    },
    {
      "id": "33375892242622",
      "color": "White",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-10.jpg?v=1783410528",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves white feature 4"
    },
    {
      "id": "33375892275390",
      "color": "White",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-11.jpg?v=1783410528",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves white scene 1"
    },
    {
      "id": "33375892308158",
      "color": "White",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-12.jpg?v=1783410527",
      "alt": "color:White | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves white scene 2"
    },
    {
      "id": "33455530770622",
      "color": "Pink",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-pink-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves pink white background main"
    },
    {
      "id": "33375892930750",
      "color": "Pink",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-31.jpg?v=1783410528",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves pink feature 1"
    },
    {
      "id": "33375892963518",
      "color": "Pink",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-32.jpg?v=1783410528",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves pink feature 2"
    },
    {
      "id": "33375892996286",
      "color": "Pink",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-33.jpg?v=1783410528",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves pink feature 3"
    },
    {
      "id": "33375893029054",
      "color": "Pink",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-34.jpg?v=1783410527",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves pink feature 4"
    },
    {
      "id": "33375893061822",
      "color": "Pink",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-35.jpg?v=1783410528",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves pink scene 1"
    },
    {
      "id": "33375893094590",
      "color": "Pink",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-36.jpg?v=1783410528",
      "alt": "color:Pink | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves pink scene 2"
    },
    {
      "id": "33455530803390",
      "color": "Yellow",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-yellow-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves yellow white background main"
    },
    {
      "id": "33375893323966",
      "color": "Yellow",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-43.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves yellow feature 1"
    },
    {
      "id": "33375893356734",
      "color": "Yellow",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-44.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves yellow feature 2"
    },
    {
      "id": "33375893389502",
      "color": "Yellow",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-45.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves yellow feature 3"
    },
    {
      "id": "33375893422270",
      "color": "Yellow",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-46.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves yellow feature 4"
    },
    {
      "id": "33375893455038",
      "color": "Yellow",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-47.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves yellow scene 1"
    },
    {
      "id": "33375893487806",
      "color": "Yellow",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-48.jpg?v=1783410528",
      "alt": "color:Yellow | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves yellow scene 2"
    },
    {
      "id": "33455530836158",
      "color": "Brown",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-brown-white-background-main-20260716.jpg?v=1784185176",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:white-background-main | Seibertron SPS-2 Plus motorcycle gloves brown white background main"
    },
    {
      "id": "33375893127358",
      "color": "Brown",
      "role": "feature-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-37.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:feature-1 | Seibertron SPS-2 Plus motorcycle gloves brown feature 1"
    },
    {
      "id": "33375893160126",
      "color": "Brown",
      "role": "feature-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-38.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:feature-2 | Seibertron SPS-2 Plus motorcycle gloves brown feature 2"
    },
    {
      "id": "33375893192894",
      "color": "Brown",
      "role": "feature-3",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-39.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:feature-3 | Seibertron SPS-2 Plus motorcycle gloves brown feature 3"
    },
    {
      "id": "33375893225662",
      "color": "Brown",
      "role": "feature-4",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-40.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:feature-4 | Seibertron SPS-2 Plus motorcycle gloves brown feature 4"
    },
    {
      "id": "33375893258430",
      "color": "Brown",
      "role": "scene-1",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-41.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:scene-1 | Seibertron SPS-2 Plus motorcycle gloves brown scene 1"
    },
    {
      "id": "33375893291198",
      "color": "Brown",
      "role": "scene-2",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-premium-summer-gallery-42.jpg?v=1783410528",
      "alt": "color:Brown | batch:sps2plus-complete-20260716 | role:scene-2 | Seibertron SPS-2 Plus motorcycle gloves brown scene 2"
    },
    {
      "id": "33455530868926",
      "color": "all",
      "role": "color-overview",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-all-color-overview-20260716.jpg?v=1784185176",
      "alt": "color:all | batch:sps2plus-complete-20260716 | role:color-overview | Seibertron SPS-2 Plus motorcycle gloves shared color overview"
    },
    {
      "id": "33455530901694",
      "color": "all",
      "role": "size-chart",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2plus-all-size-chart-20260716.jpg?v=1784185176",
      "alt": "color:all | batch:sps2plus-complete-20260716 | role:size-chart | Seibertron SPS-2 Plus motorcycle gloves shared size chart"
    }
  ]
};
  var entries = config.entries || [];
  function scope() { return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]'); }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; }
    catch (error) { return absolute(url); }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[ch]; });
  }
  function colorFieldset(root) {
    return Array.prototype.find.call(root.querySelectorAll('fieldset[data-auto-option-position]'), function (fieldset) {
      var legend = fieldset.querySelector('legend span');
      return String(legend && legend.textContent || '').trim().toLowerCase() === 'color';
    });
  }
  function selectedColor(root) {
    var fieldset = colorFieldset(root);
    var checked = fieldset && fieldset.querySelector('input[data-auto-option]:checked');
    return checked ? checked.value : 'Gray';
  }
  function colorEntries(color) { return entries.filter(function (entry) { return entry.color === color || entry.color === 'all'; }); }
  function mainEntry(color) { return entries.find(function (entry) { return entry.color === color && entry.role === 'white-background-main'; }); }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200); main.srcset = ''; main.alt = entry.alt || '';
  }
  function ensureThumb(root, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button'); thumb.type = 'button'; thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', ''); wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-sps2plus-gallery-20260716', 'true');
    thumb.setAttribute('data-sps2plus-color', entry.color);
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View ' + (entry.color === 'all' ? 'shared' : entry.color) + ' image ' + String(index + 1));
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    if (thumb.dataset.sps2plusBound !== 'true') {
      thumb.dataset.sps2plusBound = 'true';
      thumb.addEventListener('click', function () {
        root.dataset.sps2plusManualMedia = String(entry.id);
        root.dataset.sps2plusManualAt = String(Date.now());
        setMain(root, entry);
        root.querySelectorAll('[data-auto-thumb]').forEach(function (node) { node.classList.toggle('is-active', node === thumb); });
      });
    }
    return thumb;
  }
  function hydrateSwatches(root) {
    var fieldset = colorFieldset(root); if (!fieldset) return;
    fieldset.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var color = label.getAttribute('data-auto-visual-option-value') || label.getAttribute('data-auto-color-value') || '';
      var entry = mainEntry(color); var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      var current = shell.querySelector('img');
      var expectedPath = new URL(absolute(entry.src), window.location.origin).pathname;
      var currentPath = current ? new URL(current.currentSrc || current.src, window.location.origin).pathname : '';
      shell.dataset.display = color; shell.removeAttribute('style');
      if (currentPath !== expectedPath) shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(color) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(color) + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(color) + '</span>';
    });
  }
  function hydrate(root, forceMain) {
    var wrap = root.querySelector('.auto-product__thumbs'); if (!wrap) return;
    entries.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index); });
    hydrateSwatches(root);
    var color = selectedColor(root); var allowed = {};
    colorEntries(color).forEach(function (entry) { allowed[String(entry.id)] = true; });
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var show = !!allowed[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !show; thumb.style.display = show ? '' : 'none'; thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    var selectedMain = mainEntry(color); var changedColor = root.dataset.sps2plusGalleryColor !== color;
    if (forceMain || changedColor) {
      setMain(root, selectedMain);
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) { thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-id')) === String(selectedMain && selectedMain.id)); });
    }
    root.dataset.sps2plusGalleryColor = color;
  }
  function run(forceMain) {
    var root = scope(); if (!root) return; hydrate(root, !!forceMain);
    if (root.dataset.sps2plusCompleteGalleryBound === 'true') return;
    root.dataset.sps2plusCompleteGalleryBound = 'true';
    root.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[data-auto-option]')) return;
      var fieldset = event.target.closest('fieldset'); var legend = fieldset && fieldset.querySelector('legend span');
      if (String(legend && legend.textContent || '').trim().toLowerCase() !== 'color') return;
      delete root.dataset.sps2plusManualMedia;
      delete root.dataset.sps2plusManualAt;
      [0,100,300,700,1500].forEach(function (delay) { window.setTimeout(function () { run(true); }, delay); });
    });
    var main = root.querySelector('[data-auto-main-image]');
    if (main && window.MutationObserver) {
      var correcting = false;
      new MutationObserver(function () {
        if (correcting) return;
        var selected = mainEntry(selectedColor(root));
        if (!selected) return;
        var selectedPath = new URL(absolute(selected.src), window.location.origin).pathname;
        var mainPath = new URL(main.currentSrc || main.src, window.location.origin).pathname;
        var manualAt = Number(root.dataset.sps2plusManualAt || 0);
        if (mainPath !== selectedPath && Date.now() - manualAt > 2500) {
          correcting = true;
          setMain(root, selected);
          correcting = false;
        }
      }).observe(main, { attributes:true, attributeFilter:['src','srcset'] });
    }
    var fieldset = colorFieldset(root);
    if (fieldset && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.setTimeout(function () { pending = false; hydrateSwatches(root); }, 0);
      }).observe(fieldset, { subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset','style'] });
    }
  }
  run(true);
  [100,300,700,1500,3000,5000].forEach(function (delay) { window.setTimeout(function () { run(true); }, delay); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(true); }, { once:true });
  var attempts = 0; var timer = window.setInterval(function () { attempts += 1; run(false); if (attempts >= 100) window.clearInterval(timer); }, 150);
})();
// END sps2plusCompleteGallery20260716
